export enum StatusRecord {
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  CANCELED = 'canceled',
  SCHEDULED = 'scheduled'
}

export const StatusRecordTitles = {
  [StatusRecord.IN_PROGRESS]: 'На приеме',
  [StatusRecord.COMPLETED]: 'Прием окончен',
  [StatusRecord.SCHEDULED]: 'Записан',
  [StatusRecord.CANCELED]: 'Отменен'
}
